<template>
    <div>
        <div class="card">
            <div class="card-header">
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group row">
                            <label for="type_id" class="col-sm-3 col-form-label text-left">Serial Number</label>
                            <div class="col-sm-9">
                                <div class="row">
                                    <div class="col-8">
                                        <input type="text" v-model="barcode" class="form-control"/>
                                    </div>
                                    <div class="col-4">
                                        <button type="button" class="btn btn-sm btn-outline-primary" @click="search"><i class="fa fa-search"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-4">
                        <div class="row">
                          <dt class="col-md-4"><h5>Inventory</h5></dt>
                          <dd class="col-md-8"></dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Inventory No</dt>
                          <dd class="col-md-8">{{ getInventory.inventory_no}}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Product</dt>
                          <dd class="col-md-8">{{ getInventory.product_no }} - {{ getInventory.product }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Date</dt>
                          <dd class="col-md-8">{{ getInventory.inventory_date | dateFormat('DD/MM/YYYY') }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">HPP</dt>
                          <dd class="col-md-8">{{ getInventory.cost | currency}}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Branch</dt>
                          <dd class="col-md-8">{{ getInventory.branch }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Vendor</dt>
                          <dd class="col-md-8">{{ getInventory.vendor_no }} - {{ getInventory.vendor }}</dd>
                        </div>
                    </div>
                     <div class="col-md-4">
                        <div class="row">
                          <dt class="col-md-4"><h5>Sales</h5></dt>
                          <dd class="col-md-8"></dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Sale No.</dt>
                          <dd class="col-md-8">{{ getSales.sale_no }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Product</dt>
                          <dd class="col-md-8">{{ getSales.product_no }} - {{ getSales.product }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Date</dt>
                          <dd class="col-md-8">{{ getSales.sale_date }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Harga</dt>
                          <dd class="col-md-8">{{ getSales.price | currency }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Branch</dt>
                          <dd class="col-md-8">{{ getSales.branch }}</dd>
                        </div>
                        <div class="row">
                          <dt class="col-md-4">Customer</dt>
                          <dd class="col-md-8">{{ getSales.customer_no }} - {{ getSales.customer.name }}</dd>
                        </div>
                     </div>
                     <div class="col-md-4"></div>
                </div>
                <div class="row mt-5">
                  <div class="col-md-12">
                    <div class="row">
                      <dt class="col-md-4"><h5>Services</h5></dt>
                      <dd class="col-md-8"></dd>
                    </div>
                    <div class="row">
                      <table class="table table-sm table-item table-striped">
                        <thead>
                          <th>Status</th>
                          <th>Workshop No.</th>
                          <th>Date</th>
                          <th>Notes</th>
                          <th>Customer</th>
                          <th>Total</th>
                        </thead>
                        <tbody>
                          <tr v-for="s in getWorkshop" :key="s.id">
                            <td>{{ s.status }}</td>
                            <td>{{ s.workshop_no }}</td>
                            <td>{{ s.date_in }}</td>
                            <td>{{ s.notes }}</td>
                            <td>{{ s.customer }}</td>
                            <td>{{ s.total | currency }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <!-- <pre>{{ getInventory }}</pre> -->
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { productUrl, getHeader } from '@/config'

export default {
  name: 'ProductHistory',
  data () {
    return {
      barcode: '6431051C3A60',
      history: [{
        inventory: {
          id: null,
          inventory_no: null,
          serial_number: null,
          product_no: null,
          product: null,
          warehouse_no: null,
          warehouse: null,
          uom_id: null,
          qty_demand: null,
          qty_done: null,
          inventory_date: null,
          branch_no: null,
          branch: null,
          cost: '0',
          vendor: null,
          vendor_no: null
        },
        sales: {
          id: null,
          sale_no: null,
          serial_number: null,
          product_no: null,
          product: null,
          warehouse_no: null,
          warehouse: null,
          uom_id: null,
          qty: null,
          sale_date: null,
          branch_no: null,
          branch: null,
          price: '0',
          customer: {
            id: null,
            customer_no: null,
            name: null,
            group_id: null,
            email: null,
            phone: null,
            address: null,
            city_id: null,
            state_id: null,
            identity_number: null,
            vat: null,
            birthday: null,
            birthplace: null,
            twitter: null,
            facebook: null,
            instagram: null
          },
          customer_no: null
        },
        workshop: [{
          id: null,
          workshop_no: null,
          qty: null,
          product_no: null,
          product: null,
          serial_number: null,
          branch_no: null,
          branch: null,
          description: null,
          notes: null,
          customer: null,
          date_in: null,
          date_out: null,
          work_start: null,
          work_finish: null,
          total: '0',
          status: null
        }]
      }]
    }
  },
  created () {
    // Add barcode scan listener and pass the callback function
    this.$barcodeScanner.init(this.onBarcodeScanned)
  },
  destroyed () {
    // Remove listener when component is destroyed
    this.$barcodeScanner.destroy()
  },
  methods: {
    search: function () {
    //   this.onBarcodeScanned(this.barcode)
      var obj = {
        sn: this.barcode
      }
      axios.post(productUrl + '/history', obj, { headers: getHeader() })
        .then(response => {
          this.history = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data + '</pre>',
            'error'
          )
        })
    },
    onBarcodeScanned: function (barcode) {
      var obj = {
        sn: barcode
      }
      axios.post(productUrl + '/history', obj, { headers: getHeader() })
        .then(response => {
          this.history = response.data.data
        })
        .catch(error => {
          console.log(error.response)
          this.$swal(
            'Error',
            '<pre>' + error.response.data + '</pre>',
            'error'
          )
        })
    }
  },
  computed: {
    getInventory: function () {
      return this.history[0].inventory
    },
    getSales: function () {
      return this.history[0].sales
    },
    getWorkshop: function () {
      return this.history[0].workshop
    }
  }
}
</script>
